export const PREFIX_CLS = 'ui-fullcalendar';



// WEBPACK FOOTER //
// ./components/calendar/Constants.tsx